<template>
  <v-container flat fluid>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="title">Work Log</span>
      </v-card-title>
    </v-card>
     <v-row class="pt-4">
      <v-col xl="7" class="py-3" justify="center" align="center" >
        <v-btn-toggle dense v-model="type" color="primary">
           <v-btn 
            value="summary" 
            :disabled="type == 'summary'"
            @click="fetchChartData()"
          > Summary </v-btn> 
          <v-btn 
            value="bookings"
            :disabled="type == 'bookings'"
          >Bookings</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" sm="8" md="6" lg="5" xl="2" class="py-0">
        <v-menu
          ref="date_input.start.picker"
          v-model="date_input.start.picker"
          :close-on-content-click="false"
          transition="scale-transition"
          max-width="290px"
          :nudge-right="30"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_input.start.date_formatted"
              label="Start Date"
              hint="MM/DD/YYYY format"
              persistent-hint
              v-bind="attrs"
              @blur="date_input.start.date = parseDate(date_input.start.date_formatted)"
              v-on="on"
              outlined
              filled
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date_input.start.date"
            @input="date_input.start.picker = false" 
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="8" md="6" lg="5" xl="2" class="py-0">
        <v-menu
          ref="date_input.end.picker"
          v-model="date_input.end.picker"
          :close-on-content-click="false"
          transition="scale-transition"
          max-width="290px"
          :nudge-right="30"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_input.end.date_formatted"
              label="End Date"
              hint="MM/DD/YYYY format"
              persistent-hint
              v-bind="attrs"
              outlined
              filled
              @blur="date_input.end.date = parseDate(date_input.end.date_formatted)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date_input.end.date"
            @input="date_input.end.picker = false" 
            :min="date_input.end.date_min"
            :show-current="date_input.end.date_min"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col 
        cols="12" sm="8" md="6" lg="5" xl="1"
        class="py-3"  align="center"
      >
        <v-btn
          fab
          x-small
          color="default"
          @click="type == 'bookings' ? fetchClientInvoices() : fetchChartData()"
        >
          <font-awesome-icon size="lg" icon="search" />
        </v-btn>
      </v-col>
    </v-row>

    <v-row 
      v-if="type == 'summary' || type == ''" 
      class=" pt-4" 
      justify="center"
    >

      <!-- LOADER -->
      <v-col 
        xl="12"
        class="d-flex justify-center"
        v-if="invoices.loading"
      >
      <v-progress-circular
            :width="3"
            color="default"
            indeterminate
            align-self="auto"
      ></v-progress-circular>
      </v-col>

      <v-col 
        xl="12"  lg="12" 
        class="py-3 pl-5 pr-5" 
        v-if="!invoices.loading"
      >
        <line-chart :chart-data="invoice.chart.line.data"> </line-chart>
      </v-col>

    </v-row>
    <v-row v-else>
       <v-col 
        xl="12"
        class="py-3 pl-10 pr-10"  
      >
        <v-data-table
          v-if="invoice.table.items.length > 0"
          :headers="invoice.table.header"
          :items="invoices.clientInvoices.invoice.docs"
          :options.sync="invoice.table.pagination.options"
          :server-items-length="invoices.clientInvoices.invoice.totalDocs"
          :loading="invoices.loading"
        >
          <template v-slot:item.createdAt="{ item }">
            {{ moment(item.createdAt).format("MM/DD/YYYY") }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ moment(item.date).format("MM/DD/YYYY") }}
          </template>
          <template v-slot:item.start="{ item }">
            {{ moment(item.start).format("MM/DD/YYYY") }}
          </template>
          <template v-slot:item.finish="{ item }">
            {{ moment(item.finish).format("MM/DD/YYYY") }}
          </template>
          
          <template v-slot:item.total="{ item }">
            {{ item.subtotal + item.vat }}
          </template>
          <template  v-slot:no-data>
            No Data Available.  
            <v-btn
              text
              x-small
              color="default"
              @click="fetchClientInvoices()"
            >
              <font-awesome-icon size="lg" icon="sync" />
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>

import { mapState, mapActions } from "vuex";
import moment, { min } from "moment";
import LineChart from '@/components/charts/LineChart'

export default {
  components: {
    LineChart,
  },
  props: {
    client: Object,
  },
  data(vm) {
    
    let initialEndDate = moment();
    let initialStartDate =  moment().subtract(4,'weeks');

    return {
      type: "summary",
      date_input: {
        start: {
          picker: false,
          date: initialStartDate.format("YYYY-MM-DD"),
          date_formatted: vm.formatDate(initialStartDate.format("YYYY-MM-DD")),
        },
        end:{
          picker: false,
          date: initialEndDate.format("YYYY-MM-DD"),
          date_formatted: vm.formatDate(initialEndDate.format("YYYY-MM-DD")),
          date_min: initialEndDate.subtract(4,'weeks').add(1,"days").format("YYYY-MM-DD")
        }
       
      },
      invoice: {
        table:{
          header: [
            { 
                text: 'Invoice #',
                value: 'invoiceNo',
                sortable: true,
                align: 'center', 
             },
            { 
                text: 'Purchase #',
                value: 'purchaseOrderNo',
                sortable: true,
                align: 'center', 
             },
             { 
                text: 'Date',
                value: 'date',
                sortable: false,
             },
             { 
                text: 'Start',
                value: 'start',
                sortable: false,
             },
             { 
                text: 'Finish',
                value: 'finish',
                sortable: false,
                align: 'center', 
             },
             { 
                text: 'Subtotal',
                value: 'subtotal',
                sortable: false,
                align: 'end', 
             },
             { 
                text: 'VAT',
                value: 'vat',
                sortable: false,
                align: 'end', 
             },
             { 
                text: 'Total', 
                value: 'total', 
                sortable: true,  
                align: 'end', 
              },
          ],
          pagination: {
            options: {
              sortBy: ["invoiceNo"],
              sortDesc: [true],
            },
            details: {
              offset: 0,
              limit: 10,
              sortDesc: true,
              start_date: initialStartDate.format("YYYY-MM-DD"),
              end_date: moment().format("YYYY-MM-DD"),
              client_id: vm.client._id
            },
            loading: true,
          },
          items: [
            {
              'company' : "1",
              'location' : "1",
              'timesheet' : "1",
              'invoice' : "1",
              'client' : "1",
              'role' : "1",
              'site' : "1",
              'type' : "1",
              'rate' : "1",
              'createdAt' : "1",
            }
          ]
        },
        chart:{
          url_params: {
            start_date: initialStartDate.format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            client_id: vm.client._id,
            frequency: "daily" // ["weekly", "yearly", "monthly"]
          },
          line: {
            data:{
              labels: [],
              datasets: []
            },
          },
        }
      }
    };
  },
  computed: {
    ...mapState({
      invoices: state => state.invoices,
    }),
  },
  watch: { 
      "date_input.start.date" (val) {
        this.date_input.start.date_formatted = this.formatDate(this.date_input.start.date)
      },
      "date_input.end.date" (val) {
        this.date_input.end.date_formatted = this.formatDate(this.date_input.end.date)
      },
      "invoice.table.pagination.options" : {
        handler() {
          this.fetchClientInvoices()
        },
        deep: true,
      },
      async "invoices.chart_data"(val){
        await this.generateChartDetails(this.invoice.chart.url_params)
      },
      "client._id"(val,from){

        this.date_input.end.date= moment().format("YYYY-MM-DD"),
        this.date_input.start.date  = moment().subtract(4,'weeks').format("YYYY-MM-DD"),

        this.invoice.chart.url_params.start_date = this.date_input.start.date;
        this.invoice.chart.url_params.end_date = this.date_input.end.date;

        this.resetWindowHistoryDataState(); // reset data state for chart
        
      }
  },
  methods:{
    ...mapActions({
      fetchInvoicesByClient: "invoices/fetchByClient",
      fetchInvoiceChartData: "invoices/fetchInvoiceChartData",
      resetWindowHistoryDataState: "invoices/resetWindowHistoryDataState"
    }),
     async fetchChartData(){

      this.invoice.chart.url_params.start_date = this.date_input.start.date;
      this.invoice.chart.url_params.end_date = this.date_input.end.date;
      
      this.invoice.chart.url_params.client_id = this.client._id;

      await this.fetchInvoiceChartData(this.invoice.chart.url_params)

    },
    async fetchClientInvoices (){

      const { sortBy, sortDesc, page, itemsPerPage } = this.invoice.table.pagination.options

      this.invoice.table.pagination.details = {
        offset: ((page - 1) * (itemsPerPage + 1)),
        limit: itemsPerPage | 10,
        sortDesc: sortDesc === "undefined" ? false : sortDesc[0],
        start_date: this.date_input.start.date,
        end_date: this.date_input.end.date,
        client_id: this.client._id
      }

      const dataPagination = this.invoice.table.pagination.details
      
      await this.fetchInvoicesByClient(dataPagination)

    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
    },
    parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    getDailyTotalHours(start_date){
      const found = this.invoices.chart_data.filter(item => moment(start_date).isSame(moment(item.start_date)) === true );
      return found.length != 0 ? found[0].daily_total : 0 ;
    },

    async generateChartDetails(params){

      let _self = this;

      let { start_date, end_date } = params

      let label = [];
      let data = [];

      start_date = moment(start_date).format("YYYY-MM-DD");
      end_date = moment(end_date).format("YYYY-MM-DD");

      while ( !moment(start_date).isSame(moment(end_date)) ) {

        label.push(moment(start_date).format("DD/MM/YYYY"));
        data.push(_self.getDailyTotalHours(start_date))

        start_date = moment(start_date).add(1,"days").format("YYYY-MM-DD");
        
      }
     
      _self.invoice.chart.line.data.labels = label;
      _self.invoice.chart.line.data.datasets = [];
      _self.invoice.chart.line.data.datasets.push({
        label: 'TOTAL HOURS',
        data:  data,
        fill: false,
        borderColor: '#2554FF',
        backgroundColor: '#2554FF',
        borderWidth: 1
      });

    }
  },
  async mounted(){
  },
};
</script>
